<template>
  <div class="select-ref">
    <div :class="['left', showRefDataDialog ? 'show-ref' : '']">
      <el-select
        v-if="_.isEmpty(localValue)"
        :value="_.get(localValue, '[0].id')"
        filterable
        remote
        :remote-method="search"
        :loading="loading"
        :disabled="disabled"
        placeholder="请选择或搜索"
        class="is-select"
        @input="selectChange('dropdown', $event)"
        @visible-change="visibleChange"
      >
        <el-option
          style="height:100%"
          v-for="item in list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span
            style="white-space: normal;line-height: 17px;display: inline-flex;word-break: break-all;width:280px"
          >
            {{ item.label }}
          </span>
        </el-option>
      </el-select>
      <template v-else>
        <div
          class="is-text"
          :style="disabled ? 'background-color:#F5F7FA;height:32px' : 'background-color:#fff'"
        >
          {{ localValue[0].title }}
          <span v-if="!disabled" class="icon-close">
            <i class="el-icon-close" @click="selectChange('dropdown', null)"></i>
          </span>
        </div>
      </template>
    </div>
    <div
      v-if="showRefDataDialog"
      class="right"
      :class="{ 'is-disabled': disabled }"
      @click="openRefDialog"
    >
      <i class="el-icon-plus"></i>
    </div>
    <ref-data-dialog
      v-if="showRefDataDialog"
      :dialog-visible.sync="dialogVisible"
      :ref-sheet="refSheet"
      :control="control"
      :refCondition="refCondition"
      @select="selectChange('dialog', $event)"
      @data-created="refDataCreated"
    ></ref-data-dialog>
  </div>
</template>

<script>
import { getSheetViewData } from "@/api/sheet/sheetView"
import { getSheetDataById, getSheetDataForEdit } from "@/api/sheet/sheetData"
import RefDataDialog from "@/components/Sheet/RefDataDialog"
import { loadingService } from "@/utils/ui"
import { getSheet } from "@/api/sheet/sheet"

export default {
  name: "select-ref",
  components: {
    RefDataDialog
  },
  props: {
    disabled: Boolean,
    value: {
      type: Array,
      default: () => [
        // 目前只需要这两个属性
        // {
        //   id: "",
        //   title: ""
        // }
      ]
    },
    showRefDataDialog: Boolean,
    control: {
      type: Object,
      default: () => ({})
    },
    sheetDataServer: Object
  },
  data() {
    return {
      searchText: "",
      loading: false,
      list: [],
      dialogVisible: false,
      getRefDataDebounced: this._.debounce(this.getRefData, 300),
      refSheet: {},
      sheetReqPromise: null,
      reqValue: null
    }
  },
  computed: {
    isCurValueInvalid() {
      return this._.isString(this.value?.[0])
    },
    localValue() {
      if (!this.isCurValueInvalid) return this.value
      return this.reqValue ? [this.reqValue] : []
    },
    showFields() {
      return this.control.searchFields?.length
        ? this.control.searchFields
        : this.control.fields?.length
        ? this.control.fields
        : [(this.refSheet.controls || []).find(control => control.main)?._cid]
    },
    searchBody() {
      return {
        searchText: this.searchText,
        searchCids: this.showFields
      }
    },
    refCondition() {
      if (!this.sheetDataServer) return {}
      return {
        refSheetId: this.sheetDataServer.sheetId,
        refControlId: this.control?._cid,
        refSheetData: this.sheetDataServer
      }
    }
  },
  watch: {
    control: {
      immediate: true,
      handler(control) {
        if (!control) return
        const { refSheetId } = control
        this.sheetReqPromise = getSheet(refSheetId).then(sheet => {
          this.refSheet = sheet
        })
      }
    },
    value: {
      immediate: true,
      handler() {
        if (this.isCurValueInvalid) {
          this.sheetReqPromise?.then(() => {
            getSheetDataForEdit({
              dataId: this.value[0],
              appId: this.refSheet.appId,
              sheetId: this.refSheet.sheetId,
              withDetail: false,
              withString: false
            }).then(res => (this.reqValue = res))
          })
        }
      }
    }
  },
  methods: {
    openRefDialog() {
      if (this.disabled) return
      this.dialogVisible = true
    },
    // 请求数据
    getRefData() {
      this.loading = true
      return getSheetViewData({
        sheetId: this.control.refSheetId,
        ...this.searchBody,
        ...this.refCondition,
        page: 1,
        size: 20
      }).then(res => {
        this.list = res.content.map(sheetData => ({
          value: sheetData.id,
          label:
            this.showFields
              .map(cid => sheetData.data[cid])
              .filter(t => t)
              .join(" / ") || "空"
        }))
        this.loading = false
      })
    },
    // 搜索
    search(searchText) {
      this.searchText = searchText
      this.loading = true
      this.getRefDataDebounced()
    },
    visibleChange(visible) {
      if (visible) {
        this.loading = true
        this.getRefDataDebounced()
      }
    },
    // 选择
    selectChange(from, selectedVal) {
      let dataId
      if (!selectedVal) {
        this.searchText = ""
        this.$emit("input", [])
        return
      }
      if (from == "dropdown") dataId = selectedVal
      else if (from == "dialog") dataId = selectedVal.id
      let loadingInstance = loadingService()
      // 列表里的数据与实际数据有差异,所以需要重新请求一下
      getSheetDataById(this.control.refSheetId, dataId)
        .then(sheetData => {
          this.$emit("input", [sheetData])
          this.searchText && (this.list = []) // 使再次展开下拉菜单时显示无搜索文字时的结果
          this.dialogVisible = false
        })
        .finally(() => loadingInstance.close())
    },
    // 关联数据dialog中数据新建成功
    refDataCreated(sheetData) {
      this.$emit("input", [sheetData])
      this.$emit("refDataCreated")
    }
  }
}
</script>

<style lang="scss" scoped>
.select-ref {
  display: flex;
  min-height: 32px;
  align-items: flex-start;
  .left {
    flex: auto;
    height: 100%;
    &.show-ref {
      .is-select {
        ::v-deep .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
      .is-text {
        border-radius: 4px 0 0 4px;
      }
    }
    .is-select {
      width: 100%;
      ::v-deep .el-input__inner {
        border-radius: 4px;
      }
    }
    .is-text {
      @include ellipsis;
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 11px;
      border-radius: 4px;
      white-space: pre-line;
      line-height: 1.4;
      padding: 4px 10px;
      border: 1px solid #d8dce6;
      box-sizing: border-box;
      color: $color-main;
      .icon-close {
        margin-left: auto;
        color: $color-font-second;
        .el-icon-close {
          padding: 4px;
          cursor: pointer;
          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
  .right {
    @include flex-center;
    min-width: 32px;
    min-height: 32px;
    background: $color-bg-select;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #d8dce6;
    border-left-width: 0;
    cursor: pointer;
    box-sizing: border-box;
    &:hover:not(.is-disabled) {
      color: $color-main;
    }
  }
}
</style>
